import { takeLatest, put } from 'redux-saga/effects';

import {
    UPDATE_CALENDAR_SETTINGS,
    UPDATE_CALENDAR_REGISTRATION_SETTINGS,
    GET_CALENDAR_APPEARANCE_LIST,
    SHOW_PUBLISH,
    GET_CALENDAR_SETTINGS
} from './constants';

import {
    requestUpdateCalendarSettings,
    requestUpdateCalendarRegistrationSettings,
    requestAppearancesList,
    requestCalendarSettings
} from './api';

import {
    updateCalendarSettingsSuccess,
    updateCalendarRegistrationSettingsSuccess,
    getCalendarAppearancesListSuccess,
    showPublishSuccess,
    getCalendarSettignsSuccess
} from './actions';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{settings: *, type: string}>>}
 */
function* updateCalendarSettings( actionObj ) {
    const settings = yield requestUpdateCalendarSettings( actionObj.id, actionObj.value );
    if ( settings ) {
        yield put( updateCalendarSettingsSuccess( settings ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{calendar: *, type: string}>>}
 */
function* updateCalendarRegistrationSettings( actionObj ) {
    const settings = yield requestUpdateCalendarRegistrationSettings( actionObj.settingsID, actionObj.registrationSettings );
    if ( settings ) {
        yield put( updateCalendarRegistrationSettingsSuccess( settings ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{appearances: *, type: string}>>}
 */
function* getAppearancesList( actionObj ) {
    const appearances = yield requestAppearancesList( actionObj.calendarID );
    if ( appearances ) {
        yield put( getCalendarAppearancesListSuccess( appearances ) );
    }
}

/**
 *
 * @param val
 * @returns {IterableIterator<PutEffect<{type: string, value: *}>>}
 */
function* showPublish( val ) {
    if ( val ) {
        yield put( showPublishSuccess( val.value ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{settings: *, type: string}>>}
 */
function* getCalendarSettings( actionObj ) {
    const calendarSettings = yield requestCalendarSettings( actionObj.id );
    if ( calendarSettings ) {
        yield put( getCalendarSettignsSuccess( calendarSettings ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchSettings() {
    yield takeLatest( UPDATE_CALENDAR_SETTINGS, updateCalendarSettings );
    yield takeLatest( UPDATE_CALENDAR_REGISTRATION_SETTINGS, updateCalendarRegistrationSettings );
    yield takeLatest( GET_CALENDAR_APPEARANCE_LIST, getAppearancesList );
    yield takeLatest( SHOW_PUBLISH, showPublish );
    yield takeLatest( GET_CALENDAR_SETTINGS, getCalendarSettings );
}

export default watchSettings;